import '@angular/compiler';
import '@progress/kendo-angular-intl/locales/pt/all';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import '@progress/kendo-angular-intl/locales/pt/all';
registerLocaleData(localePt);

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (typeof Promise.allSettled !== 'function') {
  Promise.allSettled = (promises: any[]): Promise<any> => {
    return Promise.all(promises.map(p => Promise.resolve(p).then(
      value => ({ 
        status: 'fulfilled' as const,
        value 
      }),
      reason => ({ 
        status: 'rejected' as const, 
        reason 
      })
    )));
  };
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));